import isNil from 'lodash/isNil';
import pluralize from 'pluralize';
import { DateIcon, InProgressIcon, JunctionIcon, LimitsLocationIcon, LimitsRouteIcon, LimitsRoutesNIcon, ReportIcon, TimeIcon } from 'tombac-icons';
import { LimitSummaryContainer, LimitSummaryIcon, LimitSummaryLimit, LimitSummaryUsage } from "./limitSummaryElements";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const unitIcon = {
  'date range': DateIcon,
  day: DateIcon,
  junction: JunctionIcon,
  region: LimitsLocationIcon,
  route: LimitsRoutesNIcon,
  'report in progress': InProgressIcon,
  'route length': LimitsRouteIcon,
  report: ReportIcon,
  'time range': TimeIcon
};
pluralize.addIrregularRule('report in progress', 'reports in progress');
export default function CountLimitSummary({
  className,
  limit,
  schema,
  usage,
  variant = 'summary'
}) {
  let available = limit - usage;
  if (available < 0) available = 0;
  const Icon = unitIcon[schema.unitLabel] || ReportIcon;
  return !isNil(limit) ? /*#__PURE__*/_jsxs(LimitSummaryContainer, {
    className: className,
    schema: schema,
    children: [variant === 'summary' && /*#__PURE__*/_jsx(LimitSummaryIcon, {
      as: Icon
    }), ' ', /*#__PURE__*/_jsx(LimitSummaryLimit, {
      children: pluralize(schema.unitLabel, limit, true)
    }), ' ', typeof usage === 'number' && /*#__PURE__*/_jsxs(LimitSummaryUsage, {
      danger: limit === 0 || available / limit < 0.2,
      children: [available, " available"]
    })]
  }) : null;
}